<template>
  <div class="flex justify-between items-center mb-4 text-black">
    <div class="ml-auto flex items-center gap-2">
      <AppNotification />
      <AppProfileSearch />
    </div>
  </div>
  <div class="chat-container">
    <div class="chat-content">
      <div class="chat-panel chat-left">
        <GeneralChat />
      </div>
      <!-- <FlowChart /> -->
      <div class="chat-panel chat-right">
        <PrivateChat />
      </div>
    </div>
  </div>
</template>

<script>
import GeneralChat from './chatGrupoView.vue';
import PrivateChat from './chatPrivadoView.vue';
import AppProfileSearch from '@/components/profileSearch.vue';
import AppNotification from '@/components/notification.vue';
import FlowChart from '@/components/FlowChartComponent.vue';
export default {
  name: 'ChatView',
  components: {
    GeneralChat,
    PrivateChat,
    AppProfileSearch,
    AppNotification,
    FlowChart
  },
};
</script>

<style scoped>
.chat-container {
  display: flex;
  flex-direction: column;
  height: 100%;
}

.chat-content {
  display: flex;
  justify-content: space-between;
  gap: 10px;
  height: calc(100vh - 80px); /* Adjust height to fit the screen */
}

.chat-panel {
  flex: 1;
  background: #2f284a;
  border-radius: 10px;
  padding: 10px;
  display: flex;
  flex-direction: column;
}

.chat-left {
  margin-right: 10px;
}

.chat-right {
  margin-left: 10px;
}

button {
  padding: 10px 20px;
  border-radius: 5px;
  border: none;
  background-color: #e41616;
  cursor: pointer;
  font-size: 1rem;
}

button.active {
  background-color: #007bff;
  color: rgb(203, 214, 49);
}
</style>
